import React, {useEffect, useState} from 'react';
import {useQuery} from "../common/hooks/useQuery";
import {GetCurrentLanguage, HandleChangeLang} from "../util/ChangeLanguage";

const AuthLayout = ({ children }) => {
  const query = useQuery()
  const lang = query.get("lang")
  const [curLang,setCurLang] = useState(GetCurrentLanguage())
  useEffect(() => {
    if (lang === "vi-VN" || lang === "en-US"){
      HandleChangeLang(lang)
      setCurLang(lang)
    } else if (lang){
      HandleChangeLang("en-US")
      setCurLang("en-US")
    }
  },[curLang])
  return (
    <div className='w-full h-full'>
      {children}
    </div>
  )
}

export default AuthLayout;
